<template>
  <li>
    <AppLink
      :to="getUrl"
      class="filter-links__link"
      @click="closePanel"
    >
      {{ option.label }} <span class="filter-links__count">{{ option.count }}</span>
    </AppLink>

    <ul
      v-if="isActiveCategoryInTree(option)"
      class="filter-links-tree"
    >
      <FilterLinksItem
        v-for="child in option.children"
        :key="child.key"
        :option="child"
        :filter="filter"
        class="filter-links-tree__item"
        :class="{ 'filter-links-tree__item--active': child.active }"
      />
    </ul>
  </li>
</template>

<script setup lang="ts">
const meta = inject('meta', ref())
const route = useRoute()

const props = defineProps({
  filter: {
    type: Object,
    required: true,
  },
  option: {
    type: Object,
    required: true,
  },
})

const {
  closePanel,
} = useCatalogFiltersModal()

const getUrl = computed(() => {
  const filterKey = props.filter.key
  const queryParams = new Map(Object.entries({ filter: 1, ...route.query, [filterKey]: props.option.key }))
  let path = route.path
  const basePath = route.path

  if (meta.value?.page_type === 'plp-theme') {
    meta?.value.filters.forEach((item: any) => {
      queryParams.set(item.key, item.values.join('~'))
    })
  }
  if (['plp-brand', 'plp-filter'].includes(meta.value?.page_type) && !props.option?.urlPath?.includes('/')) {
    queryParams.delete(filterKey)
    path = (props.option.urlPath ?? props.option.key) + path
  }
  if (!['plp-brand', 'search', 'plp-filter'].includes(meta.value?.page_type)) {
    queryParams.delete(filterKey)
    path = props.option.urlPath
  }
  if (path === null) {
    path = useSanitizeUrl(basePath + props.option.key.replace(' ', '-'))
  }
  if (queryParams.size > 1 && !queryParams.has('p')) {
    return `${path}?${(new URLSearchParams(Object.fromEntries(queryParams))).toString()}`
  }

  return path
})

const isActiveCategoryInTree = (item: any) => {
  if (item.active === true) {
    return true
  }
  for (const i in item.children) {
    if (isActiveCategoryInTree(item.children[i])) {
      return true
    }
  }
}
</script>
